import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import images from '_images';
import { _ } from '_locales';
import CongratulationsModal from './CongratulationsModal';
import Answers from './Answers';
import Levels from './Levels';
import eventTracker from '../../../../../helpers/eventTracker';
import events from '../../../events';

const Container = styled.div`
  max-height: 68vh;
  overflow-y: auto;
  overflow-x: hidden;
  width: ${({ windowsWidth }) => (windowsWidth >= 850 ? '830px' : '100%')};
  display: flex;
  align-items: center;
  flex-direction: column;
`;

const LevelText = styled.h2`
  font-size: 20px;
`;

const ScoreText = styled.h2`

  font-size: 15px;
  color: #39e75f;

  &.goodJob {
    color: #39e75f;
  }

  &.oops {
    color: #ff8886;
  }
`;

const CheckOutText = styled.p`
  font-size: 10px;
  color: #808080;
  text-align: center;
`;

const FeedbackContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
`;

const FeedbackImage = styled.div`
  background-size: contain;
  background-position: center;
  width: 60px;
  height: 60px;

  &.good{
    background-image: url(${images.recycleRight.happy_emoji});
  }
  
  &.oops{
    background-image: url(${images.recycleRight.sad_emoji});
  }
`;

const FeedbackText = styled.h3`
  text-align: center;
  font-size: 12px;
`;

const Button = styled.button`
  height: 50px;
  width: ${({ windowsWidth }) => (windowsWidth >= 500 ? '200px' : '90vw')};
  bottom: 3%;
  border-radius: 8px;
  bottom: 1%;
  left: 5%;
  transform: translateY(-30px);
  margin-left: auto;
  margin-right: ${({ windowsWidth }) => (windowsWidth >= 500 ? '50px' : 'auto')};
  background-color: #00008B;
  color: white;
  box-shadow: ${({ windowsWidth }) => (
    windowsWidth >= 500 ? '0px 0px 0px 0px rgba(0, 0, 0, 0.5)' : '20px 20px 50px 50px rgba(0, 0, 0, 0.5)'
  )};
`;

const AnswersContainer = styled.div`
  width: ${({ windowsWidth }) => (windowsWidth >= 850 ? '850px' : '100%')};
  margin-bottom: 50px;
  flex-direction: column;
`;

// const CloseButton = styled.img`
//   height: 20x;
//   width: 20px;
//   border-radius: 50%;
//   display: flex;
//   margin-right: auto;
// `;

const Title = styled.div`
  display:flex;
  margin-right: auto;
  align-items: center;
  font-size: ${({ windowsWidth }) => (windowsWidth >= 500 ? '18px' : '15px')};
  font-weight: bold !important;
  color: rgba(64, 64, 64, 1);
  border-bottom: 2px solid #E7ECEF;
  padding: 5px;
  width: 100%;
`;

const LevelsContainer = styled.div`
  width: 100%;
`;

const Arrow = styled.button`
  display: flex; 
  align-items: center;
  justify-content: center;
  padding: 0 5px 0 0;
  cursor: pointer;
  transition: all .3s;
  border-radius: 50%;
  border: none;
  line-height: normal;
  background-color: ${({ background }) => background} ;

  &:hover {
    border-radius: 50%;
    background-color: #EBEBF0;
    box-shadow: rgba(99, 99, 99, 0.3) 0 2px 6px 0px;
  }

  &:disabled {
     opacity: 0.3 !important;
     cursor: not-allowed;
     box-shadow: none;
  }
`;

const levelState = {
  oops: (
    <>
      <FeedbackContainer>
        <FeedbackImage className="oops animate__animated animate__wobble" />
        <FeedbackText>
          <h3>{_('recycleRight.oops')}</h3>
        </FeedbackText>
      </FeedbackContainer>
      <CheckOutText>
        {_('recycleRight.check_out_local_program')}
      </CheckOutText>
    </>
  ),
  goodJob: (
    <FeedbackContainer>
      <FeedbackImage className="good animate__animated animate__rubberBand" />
      <FeedbackText>
        <h3>{_('recycleRight.good_job')}</h3>
      </FeedbackText>
    </FeedbackContainer>
  )
};

/**
 * After user answer all the questions of a level, this component shows
 * the correct and wrongs answers with their corresponding details and images
 *
 */

const RoundResult = ({
  clearedLevel,
  onContinue,
  onPlayAgain,
  doneMaterials,
  currentLevelKey,
  recycleRightData,
  playAgain,
  iamDone,
  numOfTimeOuts,
  windowsWidth,
}) => {
  const roundMaterials = recycleRightData[currentLevelKey];
  const numOfRounds = roundMaterials.length;
  const currentDnMt = doneMaterials.slice(doneMaterials.length - numOfRounds, doneMaterials.length);

  const correctAnswers = currentDnMt.filter((mat) => mat.split('-')[0] === 'correct');
  const numOfCorrectAnswers = correctAnswers.length;
  const currentCorrctAnswersId = correctAnswers.map((mat) => mat.split('-')[1]);
  const correctAnswersMaterials = {
    roundMaterials: roundMaterials.filter((mat) => currentCorrctAnswersId.indexOf(
      mat.mat_id.toString()
    ) > -1)
  };

  const wrongAnswers = currentDnMt.filter((mat) => mat.split('-')[0] === 'wrong');
  const numOfWrongAnswers = wrongAnswers.length;
  const currentWrongAnswersId = wrongAnswers.map((mat) => mat.split('-')[1]);
  const wrongAnswersMaterials = {
    roundMaterials: roundMaterials.filter((mat) => currentWrongAnswersId.indexOf(
      mat.mat_id.toString()
    ) > -1)
  };

  const levelStatus = (numOfCorrectAnswers / (numOfCorrectAnswers + numOfWrongAnswers) >= 0.8) ? 'goodJob' : 'oops';

  const [congratsModalVisible, setCongratsModalVisible] = useState(
    (Number(currentLevelKey.split('_')[1].split('_')[0]) === (Object.keys(recycleRightData).length)) && levelStatus === 'goodJob'
  );

  useEffect(() => {
    if (levelStatus === 'oops') {
      // track event
      eventTracker(events.DZ_RR_LEVEL_FAIL, {
        level: Number(currentLevelKey.split('_')[1].split('_')[0]),
        correct: numOfCorrectAnswers,
        total: numOfCorrectAnswers + numOfWrongAnswers,
        timeouts: numOfTimeOuts
      });
    }
    if (levelStatus === 'goodJob') {
      // track event
      eventTracker(events.DZ_RR_LEVEL_SUCCESS, {
        level: Number(currentLevelKey.split('_')[1].split('_')[0]),
        correct: numOfCorrectAnswers,
        total: numOfCorrectAnswers + numOfWrongAnswers,
        timeouts: numOfTimeOuts
      });
    }
  }, [levelStatus]);

  const onCloseModal = () => {
    setCongratsModalVisible('Done');
  };

  return (
    <>
      {congratsModalVisible && (congratsModalVisible !== 'Done')
        && (
          <CongratulationsModal
            isVisible={congratsModalVisible}
            onContinue={onContinue}
            clearedLevel={clearedLevel}
            playAgain={playAgain}
            onClose={onCloseModal}
            iamDone={iamDone}
          />
        )}
      <>
        <Container windowsWidth={windowsWidth}>
          <Title windowsWidth={windowsWidth}>
            <Arrow background="#fff" onClick={iamDone}>
              &#8678;
            </Arrow>
            {_('education.recycle_right')}
          </Title>
          {/* <CloseButton src={images.recycleRight.close} onClick={iamDone} /> */}
          <LevelsContainer>
            <Levels
              levels={recycleRightData}
              currentLevelKey={currentLevelKey}
              modalVisible="true"
              windowsWidth={windowsWidth}
            />
          </LevelsContainer>
          <LevelText>
            {_('recycleRight.level_lower_case')}
            {' '}
            {clearedLevel}
          </LevelText>
          <ScoreText className={(levelStatus === 'goodJob' && 'goodJob') || (levelStatus === 'oops' && 'oops')}>
            {_('recycleRight.score')}
            {' '}
            {numOfCorrectAnswers}
            /
            {numOfCorrectAnswers + numOfWrongAnswers}
          </ScoreText>
          {levelState[levelStatus]}
          <AnswersContainer>
            <Answers
              answerTitle="WRONG ANSWERS"
              answersMaterials={wrongAnswersMaterials}
            />
            <Answers
              answerTitle="CORRECT ANSWERS"
              answersMaterials={correctAnswersMaterials}
            />
          </AnswersContainer>
        </Container>
        {
          levelStatus === 'goodJob' && !congratsModalVisible && (congratsModalVisible !== 'Done') && (
            <Button onClick={onContinue} windowsWidth={windowsWidth}>
              {_('recycleRight.next_level_button')}
            </Button>
          )
        }
        {
          levelStatus === 'oops' && (
            <Button onClick={onPlayAgain} windowsWidth={windowsWidth}>
              {_('recycleRight.play_again_button')}
            </Button>
          )
        }
        {
          levelStatus === 'goodJob' && (congratsModalVisible === 'Done') && (
            <Button onClick={iamDone} windowsWidth={windowsWidth}>
              {_('recycleRight.done')}
            </Button>
          )
        }
      </>
    </>
  );
};

export default connect(
  (store) => ({
    recycleRightData: store.education.recycle_right
  })
)(RoundResult);
